import { ChevronDown } from 'lucide-react';
import { FILMSTRIP_ARROW_CLASS } from './filmstrip-scroll';

/**
 * The prev/next pair every strip steps with: the portfolio and service
 * filmstrips, and the portfolio showcase. ONE component, because the three
 * copies it replaces were the same markup with different labels, and a fix to
 * any of them (the `aria-disabled` contract below, the arrow's colours) had to
 * be made three times.
 *
 * THE END STATE IS `aria-disabled`, NEVER THE NATIVE `disabled`. A native
 * `disabled` pulls the button out of the focus order the instant it applies, and
 * it applies at exactly the moment a keyboard user has just pressed that arrow to
 * reach the end — so focus falls to `<body>` mid-sequence: the focus ring
 * vanishes, a screen reader loses its place, and the next keypress lands on
 * nothing. `aria-disabled` tells a screen reader the same thing ("dimmed",
 * "unavailable") while leaving the button focusable and clickable, so a press
 * at an end still reaches `onStep`, and the CALLER's clamp is what makes it do
 * nothing. `FILMSTRIP_ARROW_CLASS` keys its dim and its hovers off the same
 * attribute.
 *
 * No hooks and no state: whatever renders this is already a client component
 * holding the position it reports.
 */
export const StripArrows: React.FC<{
  prevLabel: string;
  nextLabel: string;
  canPrev: boolean;
  canNext: boolean;
  onStep: (dir: 1 | -1) => void;
}> = ({ prevLabel, nextLabel, canPrev, canNext, onStep }) => (
  <div className="flex flex-none gap-2">
    <button
      type="button"
      aria-label={prevLabel}
      aria-disabled={!canPrev}
      onClick={() => onStep(-1)}
      className={FILMSTRIP_ARROW_CLASS}
    >
      <ChevronDown className="size-5 rotate-90" />
    </button>
    <button
      type="button"
      aria-label={nextLabel}
      aria-disabled={!canNext}
      onClick={() => onStep(1)}
      className={FILMSTRIP_ARROW_CLASS}
    >
      <ChevronDown className="size-5 -rotate-90" />
    </button>
  </div>
);
